/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserProfile } from '../../models/user-profile';

export interface GetUserProfile$Params {
}

export function getUserProfile(http: HttpClient, rootUrl: string, params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserProfile>> {
  const rb = new RequestBuilder(rootUrl, getUserProfile.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserProfile>;
    })
  );
}

getUserProfile.PATH = '/personalspace';
